<main class="min-vh-100 py-4 py-lg-5" style="background-color: var(--ts-surface-base-inverse);">
    <div class="container">
        <div class="col-xl-10 mx-auto">
            @if (state$ | async; as state) {
                @if (state.venue; as venue) {
                    <a
                        [routerLink]="state.landingPagePath"
                        class="btn btn-link p-0 mb-4 text-decoration-none text-start"
                    >
                        <i class="bi bi-arrow-left me-2" aria-hidden="true"></i>
                        Back to venue page
                    </a>

                    @if (venue.businessDisplayName) {
                        <h1 class="mb-4" data-testid="booking-policy-business-name">
                            {{ venue.businessDisplayName }}
                        </h1>
                    }

                    <div class="row g-4 align-items-start">
                        @if (state.terms || state.refunds || state.privacy) {
                            <aside class="col-lg-3 order-lg-2">
                                <nav
                                    class="hstack gap-3 align-items-start p-3 rounded-5"
                                    style="background-color: var(--ts-surface-subtle);"
                                    aria-label="Policy sections"
                                >
                                    <i class="bi bi-file-text fs-6 text-dark flex-shrink-0" aria-hidden="true"></i>
                                    <div class="vstack gap-2" style="min-width: 0;">
                                        <p class="text-secondary small fw-normal mb-0">On this page</p>
                                        <ul class="list-unstyled vstack gap-2 mb-0">
                                            @if (state.terms) {
                                                <li><a class="btn btn-link p-0 text-decoration-none text-start" [href]="state.landingPagePath + '/booking-policy#terms-and-conditions-section'">Terms and Conditions</a></li>
                                            }
                                            @if (state.refunds) {
                                                <li><a class="btn btn-link p-0 text-decoration-none text-start" [href]="state.landingPagePath + '/booking-policy#refund-policy-section'">Refund Policy</a></li>
                                            }
                                            @if (state.privacy) {
                                                <li><a class="btn btn-link p-0 text-decoration-none text-start" [href]="state.landingPagePath + '/booking-policy#privacy-policy-section'">Privacy Policy</a></li>
                                            }
                                        </ul>
                                    </div>
                                </nav>
                            </aside>
                        }
                        <div class="col-lg-9 order-lg-1 vstack gap-4 quill-flush">
                            @if (state.terms) {
                                <section id="terms-and-conditions-section" aria-labelledby="terms-and-conditions-heading" tabindex="-1">
                                    <h2 id="terms-and-conditions-heading" class="h4">Terms and Conditions</h2>
                                    <quill-view [content]="state.terms" [sanitize]="true" (onEditorCreated)="scrollToRequestedPolicy()" />
                                </section>
                            }
                            @if (state.refunds) {
                                <section id="refund-policy-section" aria-labelledby="refund-policy-heading" tabindex="-1">
                                    <h2 id="refund-policy-heading" class="h4">Refund Policy</h2>
                                    <quill-view [content]="state.refunds" [sanitize]="true" (onEditorCreated)="scrollToRequestedPolicy()" />
                                </section>
                            }
                            @if (state.privacy) {
                                <section id="privacy-policy-section" aria-labelledby="privacy-policy-heading" tabindex="-1">
                                    <h2 id="privacy-policy-heading" class="h4">Privacy Policy</h2>
                                    <quill-view [content]="state.privacy" [sanitize]="true" (onEditorCreated)="scrollToRequestedPolicy()" />
                                </section>
                            }
                        </div>
                    </div>
                } @else if (state.loading) {
                    <p role="status" class="text-secondary">Loading Terms and Conditions…</p>
                } @else {
                    <div role="alert">
                        <h1 class="h4">Unable to load Terms and Conditions</h1>
                        <p class="text-secondary">Please try again later.</p>
                    </div>
                }
            }
        </div>
    </div>
</main>
